import React, { useState } from 'react';
import QuestList from '../components/quests/QuestList';
import GardenGames from '../components/quests/GardenGames';
import { Flower2Icon, LeafIcon, GamepadIcon, ListIcon } from 'lucide-react';
const QuestsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'quests' | 'games'>('quests');
  return <div className="py-8 md:py-12 relative" data-id="element-947">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 text-green-200 opacity-30 transform rotate-45" data-id="element-948">
        <Flower2Icon size={120} data-id="element-949" />
      </div>
      <div className="absolute bottom-0 left-0 text-green-200 opacity-30 transform -rotate-15" data-id="element-950">
        <LeafIcon size={100} data-id="element-951" />
      </div>
      <div className="mb-8 relative z-10" data-id="element-952">
        <h1 className="text-3xl font-bold text-green-800 mb-2 flex items-center" data-id="element-953">
          <LeafIcon size={24} className="mr-2 text-green-600" data-id="element-954" />
          Sacred Garden Quests
        </h1>
        <p className="text-gray-600 pl-9" data-id="element-955">
          Restore your gardens through mindful actions and reflections
        </p>
        <div className="absolute w-32 h-1 bg-gradient-to-r from-green-500 to-transparent rounded mt-2 ml-9" data-id="element-956"></div>
      </div>
      {/* Tab navigation */}
      <div className="flex border-b border-gray-200 mb-6" data-id="element-957">
        <button className={`py-2 px-4 font-medium flex items-center ${activeTab === 'quests' ? 'text-green-600 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('quests')} data-id="element-958">
          <ListIcon size={18} className="mr-2" data-id="element-959" />
          Quests
        </button>
        <button className={`py-2 px-4 font-medium flex items-center ${activeTab === 'games' ? 'text-green-600 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('games')} data-id="element-960">
          <GamepadIcon size={18} className="mr-2" data-id="element-961" />
          Garden Games
        </button>
      </div>
      {/* Content based on active tab */}
      {activeTab === 'quests' ? <QuestList data-id="element-962" /> : <GardenGames data-id="element-963" />}
      {/* Bottom decorative element */}
      <div className="flex justify-center mt-12 text-green-400 opacity-50" data-id="element-964">
        <div className="relative" data-id="element-965">
          <Flower2Icon size={32} data-id="element-966" />
          <div className="absolute w-64 h-px bg-gradient-to-r from-green-300 to-transparent top-1/2 -left-64" data-id="element-967"></div>
          <div className="absolute w-64 h-px bg-gradient-to-l from-green-300 to-transparent top-1/2 -right-64" data-id="element-968"></div>
        </div>
      </div>
    </div>;
};
export default QuestsPage;